<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>传真</li>
                <li><a href="#">发传真</a></li>
            </ul>
        </div>
        <div class="formbody">
            <div id="usual1" class="usual"> 
  	            <div class="formbody">
                    <div class="formtitle"><span>发传真</span></div>
                    <ul class="forminfo">                           
                        <li>
                            <label>对方传真号<b>*</b></label>
                            <textarea name="" v-model="faxnum" cols="" rows="" class="textinput left maringht10" style="overflow-y:auto;height:50px;" placeholder="注意:1 请加区号;2 多个号码间用半角英文‘,’隔开； 也可按一行一个txt上传或者先将txt文件上传到传真群发录中;">

                            </textarea>
                        </li>    
                        <li>
                            <label> &nbsp; </label>
                            <div class="buttonupload  click maringht10" @click="addTxl()"> 通讯录添加 </div> 
                            <div style="float: left; padding-right: 10px;"> 
                                <el-upload
                                    class="upload-demo"
                                    :on-success="uploadTxtSuccess"
                                    :action=faxTxtUploadUrl
                                    accept=".txt" 
                                    :show-file-list="false"
                                    :before-upload="beforeUploadTxt"
                                    :headers="uploadHeaders"
                                    :on-change="handleChange">
                                    <el-button size="small" type="primary">点击文件导入（txt记事本格式）</el-button>
                                </el-upload> 
                            </div>
                            <div class="buttonupload  click maringht10" @click="addFaxContTxt()"> 导入群发录 </div>
                        </li>    
                        <li>
                            <label>传真主题<b>*</b></label>
                            <input type="text" v-model="title" pattern="传真主题，50字以内" class="dfinput" />
                        </li>
                        <li>
                            <label>传真文件<b>*</b></label>
                            <input type="text" v-model="faxfilesrcname" class="dfinput" style="float:left" />
                            <el-upload
                                    class="upload-demo" style="float:left"
                                    :on-success="uploadFaxFileSuccess"
                                    :action=faxFileUploadUrl
                                    accept=".txt,application/msexcel,application/msword,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
                                    :show-file-list="false"
                                    :before-upload="beforeUploadFaxFile"
                                    :headers="uploadHeaders"
                                    :on-change="handleChange">
                                    <el-button size="small" type="primary">{{btnName}}</el-button>
                                </el-upload>
                        </li>
                        <li>
                            <label>费用<b></b></label>
                            <b>每分钟0.3元</b>
                        </li> 
                        <li>
                            <label>&nbsp;</label><input class="sure" type="button" @click="sendfax()" value=" 提交 ">
                        </li>
                    </ul>

    
                    <div class="jian">&nbsp;</div>
                    <div class="welinfo">
                        <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                        <b>注意</b>
                    </div>
                    <ul class="infolist">
                        <li class="ea2020">1)传真支持发分机了，请在总机分机间加 - 号，如 057187654321-123 </li>
                        <li class="ea2020">2)系统支持的传真文件为doc,docx,xls,xlsx,pdf, 图片必须插入到WORD文档里面，然后再上传发送。</li>
                        <li class="ea2020">大图片请先缩小精度或尺寸，以免造成发送时间过长；可以转存成适合大小的黑白GIF或PNG再放入WORD里。</li>
                        <li class="ea2020">3)传真文件控制在4M内</li> 
                        <li class="ea2020">4)EXCEL文件只能打印默认的SHEET1工作簿，其他工作簿页面不能打印。</li>
                        <li class="ea2020">5)上传的传真文件不能加密。</li>
                        
                    </ul>
                    
                </div> 
	        </div> 
        </div>
        <!--tip1 通讯录-->
        <div class="tip tip1">        
    	    <div class="tiptop"><span>通讯录</span><a></a></div>        
            <div class="tipinfo cen ovhi">      
                <div class="cen ovhi">
                    <label class="left lh33">选择组 &nbsp; </label>
                    <div class="cityleft">
	                    <el-select v-model="txlgroupid" @change="pageChangeTxl()" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option
                                v-for="item in txlGroupList"
                                :key="item.groupid"
                                :label="item.groupname"
                                :value="item.groupid">
                            </el-option>
                        </el-select>
                    </div>
                </div>        
                <table class="tablelist">
    	            <thead>
    	                <tr>
                            <th>
                                <input name="allCheck" id="allCheck" @click="changAllCheck()" type="checkbox" value=""/>
                            </th>
                            <th>姓名</th>
                            <th>号码</th>
                        </tr>
                    </thead>
                    <tbody>    
                        <tr>
                            <td colspan="3" v-show="isSearch">查询中....</td>
                        </tr>    
                        <tr v-for="item in txlContList">
                            <td><input name="txlfax" type="checkbox" :value="item.name + '{'+item.fax1.trim()+'}'" /></td>
                            <td>{{item.name}}</td>
                            <td>{{item.fax1}}</td>
                        </tr>
                    </tbody>
                </table>        
                <div class="cen pat20 ovhi">
                    <input name="" type="button"  class="sure" @click="checkok()"  value="确定" />&nbsp;
                    <input name="" type="button"  class="cancel" @click="close()"  value="取消" />
                </div>    
            </div>    
        </div>
        <!--tip1 end-->
        <!--tip2 传真群发录-->
        <div class="tip tip2">        
    	    <div class="tiptop"><span>传真群发录</span><a></a></div>        
            <div class="tipinfo cen ovhi">     
                <table class="tablelist">
    	            <thead>
    	                <tr>
                            <th>
                                
                            </th>
                            <th>文件名</th>
                            <th>号码个数</th>
                        </tr>
                    </thead>
                    <tbody>     
                        <tr v-for="(item,index) in faxContTxtList">
                            <td><input type="radio" v-model="sctfile" name="radsct" :value="index" /></td>
                            <td>{{item.filename}}</td>
                            <td>{{item.countnum}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="pagin">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="pageIndex"
                        :page-size="50"
                        layout="total, prev, pager, next"
                        :total="totalCount">
                    </el-pagination>
                </div>
                <div class="cen pat20 ovhi">
                    <input name="" type="button"  class="sure" @click="checkoksct()"  value="确定" />&nbsp;
                    <input name="" type="button"  class="cancel" @click="closesct()"  value="取消" />
                </div>                     
            </div>    
        </div>
        <!--tip1 end-->
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            faxnum:'',
            title:'',
            filename:'',
            format:'fax',
            txtpath:'',
            txtfilesrcname:'',
            faxfilepath:'',
            faxfilesrcname:'',
            btnName:'上传文件',
            faxFileUploadUrl:this.GLOBAL.serverSrc + '/fax/uploadfaxfile.json',
            faxTxtUploadUrl:this.GLOBAL.serverSrc + '/fax/uploadtxtfile.json',
            uploadHeaders:{},
            faxnumcount:0,
            txlGroupList:[],
            txlContList:[],
            isSearch:true,
            faxContTxtList:[],
            sctfile:'',
        }
    },
    mounted(){
        this.uploadHeaders.token = this.GLOBAL.token;       
    },
    methods:{
        uploadFaxFileSuccess(response){
            // console.log(JSON.stringify(response))
            if (response.code === '0000000') {
                this.faxfilepath = response.txtPath;
                this.faxfilesrcname = response.srcFileName;
                this.btnName = "重新上传";
            }
            else if("0000006" == response.code){
                // this.buttonDisabled = false
                this.$alert(response.message, '格式错误，文件必须是txt格式！', {
                    confirmButtonText: '确定'
                })
                this.$refs.upload.clearFiles()
            }
            else{
                // console.log(JSON.stringify(response.data))
            }
        },
        beforeUploadFaxFile(file){            
            if (['text/plain','application/msexcel','application/msword','application/pdf','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.openxmlformats-officedocument.wordprocessingml.document'].indexOf(file.type) == -1) {
                this.$message.error('文件格式暂不支持！');
                return false;
            }
            this.uploadingShow = true;
        },
        handleChange(file, fileList) {
            
        },
        uploadTxtSuccess(response){
            // console.log(JSON.stringify(response))
            if (response.code === '0000000') {
                this.txtpath = response.txtPath;
                this.txtfilesrcname = response.srcFileName;
                this.faxnumcount = response.mobileNum;
                this.format="txt";
                this.faxnum = "您的号码文件" + response.srcFileName + "上传成功.";
                this.btnName = "重新上传";
            }
            else if("0000006" == response.code){
                // this.buttonDisabled = false
                this.$alert(response.message, '格式错误，文件必须是txt格式！', {
                    confirmButtonText: '确定'
                })
                this.$refs.upload.clearFiles()
            }
            else{
                // console.log(JSON.stringify(response.data))
            }
        },
        beforeUploadTxt(file){
            if (['text/plain'].indexOf(file.type) == -1) {
                this.$message.error('文件格式暂不支持！');
                return false;
            }
        },
        sendfax(){
            if(this.faxnum.trim() == ''){
                alert("对方传真号码不能为空！");
                return false;
            }
            if(this.title.trim() == ''){
                alert("传真标题不能为空！");
                return false;
            }
            if(this.title.trim().length > 50){
                alert("传真标题长度字数控制在50字内！");
                return false;
            }
            if(this.faxfilepath.trim().length < 1){
                alert("请上传传真文件！");
                return false;
            }
            let that = this;
            let data = {faxnum:this.faxnum,title:this.title,format:this.format,txtpath:this.txtpath,txtfilesrcname:this.txtfilesrcname,faxfilepath:this.faxfilepath,faxfilesrcname:this.faxfilesrcname,faxnumcount:this.faxnumcount};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/fax/sendfax.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("传真已提交成功，客服审核后自动发送，切勿重复提交！");
                    that.$router.push('/faxcheck')
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        addTxl(){
            $(".tip1").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip1").fadeOut(200);
            })
            this.pageChangeTxl();
        },
        pageChangeTxl(){
            var that = this
            let data = {'groupid':this.txlgroupid}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/gettxlcontfax.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.txlContList = res.data.txlContList;
                    that.txlGroupList = res.data.txlGroupList;
                    that.isSearch = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
            // checkok();
            
        },
        checkok(){
            var info = '';
            var checkers = document.getElementsByName('txlfax');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    if(info =='')
                        info = checkers[i].value.trim();
                    else
                        info = info + ',' + checkers[i].value.trim();
                }
            }
            if(this.faxnum == '')
                this.faxnum = info.trim();
            else
                this.faxnum = this.faxnum + "," + info.trim();
            this.closeTxl();
        },
        closeTxl(){
            $(".tip1").fadeOut(200);
        },
        changAllCheck(){
            var checkers = document.getElementsByName('txlfax');
            if (document.getElementById("allCheck").checked == true)
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = true;
                }
            }
            else
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = false;
                }
            }
        },
        addFaxContTxt(){
            $(".tip2").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip2").fadeOut(200);
            })
            this.pageChangeFaxContTxl();
        },
        pageChangeFaxContTxl(pageIndex){
            var that = this
            let data = {pageIndex:pageIndex,pageSize:50}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/fax/getpagefaxconttxt.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.faxContTxtList = res.data.faxContTxtList;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        checkoksct(){
            var index = -1;
            var checkers = document.getElementsByName('radsct');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    index = checkers[i].value;
                }
            }
            if(index < 0){
                alert("请先选择要导入的群发录！");
                return;
            }
            //alert(this.smsContTxtList[index].filepath + "," + this.smsContTxtList[index].smscount);
            this.format = 'txt';
            this.txtpath = this.faxContTxtList[index].filepath;
            this.faxnum = "您的号码文件" + this.faxContTxtList[index].filename + "上传成功.";
            this.txtfilesrcname = this.faxContTxtList[index].filename;
            this.faxnumcount = this.faxContTxtList[index].countnum;
            this.closesct();
        },
        closesct(){
             $(".tip2").fadeOut(200);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/fax/faxsend.vue